import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../firebase/firebase';
import { GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { BiBuilding } from 'react-icons/bi';
import PortalLoginShell from '../../components/shared/PortalLoginShell';

const CompanyLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError('');

    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: 'select_account' });

    try {
      const result = await signInWithPopup(auth, provider);
      const email = (result.user.email || '').toLowerCase();

      if (!email) {
        await signOut(auth);
        setError('Could not read email from Google account.');
        return;
      }

      const adminSnap = await getDoc(doc(db, 'companyAdmins', email));
      if (!adminSnap.exists()) {
        await signOut(auth);
        setError(`${email} is not authorized as a company admin. Contact your platform administrator.`);
        return;
      }

      const adminData = adminSnap.data();
      const companySnap = await getDoc(doc(db, 'companies', adminData.companyId));
      if (!companySnap.exists()) {
        await signOut(auth);
        setError('Linked company record was not found. Contact support.');
        return;
      }

      localStorage.setItem(
        'companyData',
        JSON.stringify({ ...companySnap.data(), id: companySnap.id, adminData }),
      );
      navigate('/company');
    } catch (err) {
      if (err.code === 'auth/popup-closed-by-user' || err.code === 'auth/cancelled-popup-request') {
        setError('');
      } else {
        console.error('Company sign-in error:', err);
        setError(err.message || 'Sign-in failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <PortalLoginShell
      portalLabel="Company Admin"
      title="Manage your team's benefits in one place."
      description="Add employees, set their tier, and watch which Loysta perks they're using — all from your company portal."
      accent="#00bf63"
      Icon={BiBuilding}
      onGoogleSignIn={handleGoogleSignIn}
      loading={loading}
      error={error}
      footerHint="Sign in with the Google account your platform administrator added to the whitelist."
      otherPortals={[
        { to: '/admin/login', label: 'Super Admin' },
        { to: '/vendor/login', label: 'Vendor login' },
      ]}
    />
  );
};

export default CompanyLogin;
